import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "size"];
import styled from 'styled-components';
import { LayoutBox } from '../Layout/LayoutBox';
import { useTheme } from '../useTheme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NULL_COLOR = 'var(--layout-lib-border-color)';
const StyledDonutSVG = styled.svg.withConfig({
  displayName: "ChartDonut__StyledDonutSVG",
  componentId: "rwkyk4-0"
})(["block-size:100%;border-radius:100%;inline-size:100%;"]);
const StyledChart = styled.div.withConfig({
  displayName: "ChartDonut__StyledChart",
  componentId: "rwkyk4-1"
})(["background:conic-gradient(", ");block-size:100%;inline-size:100%;"], ({
  gradientDefinition
}) => gradientDefinition);
const convertToDegrees = num => Math.round(num / 100 * 360);
const convertToPercent = (value, totalValue) => Math.round(value / totalValue * 100);
const dataVizColors = ['fill-info-default', 'fill-brand-default'];
const getDataVizColor = ({
  index,
  defaultColor
}) => {
  const color = dataVizColors[index];
  return color ? `var(--trellis-color-${color})` : defaultColor;
};
export const ChartDonut = _ref => {
  let {
      data,
      size = '4rem'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    color: themeColors
  } = useTheme();
  const totalValue = [...data].reduce((a, b) => a + b.value, 0);
  const isTotalZero = totalValue === 0;
  const defaultColor = themeColors['fill-info-default'];
  const mappedData = data.map((item, index, array) => {
    const prevItem = index > 0 ? array[index - 1] : null;
    const prevCount = (prevItem === null || prevItem === void 0 ? void 0 : prevItem.count) || 0;
    const count = (item.count || 0) + prevCount;
    const endValue = count + item.value;
    const startValue = (prevItem === null || prevItem === void 0 ? void 0 : prevItem.count) || 0;
    return Object.assign({}, item, {
      count,
      endDegrees: convertToDegrees(convertToPercent(endValue, totalValue)),
      endPercent: convertToPercent(endValue, totalValue),
      endValue,
      startDegrees: convertToDegrees(convertToPercent(startValue, totalValue)),
      startPercent: convertToPercent(startValue, totalValue),
      startValue
    });
  });
  const gradientDefinition = mappedData.map((chart, index) => {
    const {
      startDegrees,
      endDegrees
    } = chart;
    const color = isTotalZero ? NULL_COLOR : data[index].color || getDataVizColor({
      index,
      defaultColor
    });

    /**
     * These render the start and end degrees for conic-gradient
     * If no data is present, the chart will render a full circle (1 to 360 degrees)
     * If the end degrees are really small, the chart will render a small slice (0 to 5 degrees)
     */
    const displayStartDegrees = isTotalZero ? 1 : startDegrees;
    const displayEndDegrees = isTotalZero ? 360 : endDegrees || 5;
    return ` ${color} ${displayStartDegrees}deg ${displayEndDegrees}deg`;
  }).join();
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
    blockSize: size,
    inlineSize: size,
    children: /*#__PURE__*/_jsxs(StyledDonutSVG, {
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("clipPath", {
        id: "hole",
        children: /*#__PURE__*/_jsx("path", {
          d: "M 50 0 a 50 50 0 0 1 0 100 50 50 0 0 1 0 -100 v 18 a 2 2 0 0 0 0 64 2 2 0 0 0 0 -64"
        })
      }), /*#__PURE__*/_jsx("foreignObject", {
        clipPath: "url(#hole)",
        height: "100",
        width: "100",
        x: "0",
        y: "0",
        children: /*#__PURE__*/_jsx(StyledChart, {
          gradientDefinition: gradientDefinition
        })
      })]
    })
  }));
};